module.exports = __webpack_public_path__ + "static/media/reports_inventory-saved-searches.8a904664.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/reports_inventory-saved-searches.md
// module id = 1111
// module chunks = 0